import React from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import JobApplicationsPageContainer from 'buyside/components/container/JobApplicationsPage/JobApplicationsPageContainer';

const JobApplicationsPageRoot = ({ jobPostId }) => {
  return (
    <ErrorBoundary pageName="job applications">
      <JobApplicationsPageContainer jobPostId={jobPostId} />
    </ErrorBoundary>
  );
};

export default JobApplicationsPageRoot;
